import React from "react";

import { FieldGroup } from "../../components";
import { currencyOptions } from "../../core/currency";

// Pre-multicurrency wording for the legacy five (EURO/DOLLARS labels).
const LEGACY_CURRENCY_NAMES = { eur: "EURO", usd: "DOLLARS" };
const costsCurrencyOptions = () =>
  currencyOptions().map((o) => ({
    ...o,
    name: LEGACY_CURRENCY_NAMES[o.id] ?? o.name,
  }));

export function CostFields({ disabled = false }) {
  return (
    <>
      <div className="row">
        <div className="col-12 col-md-3 pr-md-16">
          <FieldGroup
            name="costs_currency"
            type="select"
            options={costsCurrencyOptions()}
            placeholder="Costs Currency"
            disabled={disabled}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-sm-6 col-md-3 pr-sm-16 pr-md-16">
          <FieldGroup
            name="polishing"
            type="numberFormat"
            persistLabel
            placeholder="Polishing:"
            inputStyle={{ paddingLeft: "105px" }}
            disabled={disabled}
          />
        </div>
        <div className="col-12 col-sm-6 col-md-3 pr-sm-16 pr-md-16">
          <FieldGroup
            name="accessories"
            type="numberFormat"
            persistLabel
            placeholder="Accessories:"
            inputStyle={{ paddingLeft: "122px" }}
            disabled={disabled}
          />
        </div>
        <div className="col-12 col-sm-6 col-md-3 pr-sm-16 pr-md-16">
          <FieldGroup
            name="shipping"
            type="numberFormat"
            persistLabel
            placeholder="Shipping:"
            inputStyle={{ paddingLeft: "96px" }}
            disabled={disabled}
          />
        </div>
        <div className="col-12 col-sm-6 col-md-3 pr-sm-16 pr-md-16">
          <FieldGroup
            name="travel"
            type="numberFormat"
            persistLabel
            placeholder="Travel:"
            inputStyle={{ paddingLeft: "80px" }}
            disabled={disabled}
          />
        </div>
      </div>
    </>
  );
}
